import { render, staticRenderFns } from "./chartAndTable.vue?vue&type=template&id=1a640106&scoped=true&"
import script from "./chartAndTable.vue?vue&type=script&lang=js&"
export * from "./chartAndTable.vue?vue&type=script&lang=js&"
import style0 from "./chartAndTable.vue?vue&type=style&index=0&id=1a640106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a640106",
  null
  
)

export default component.exports